// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ao-b";
export var colorBlue = "_ao-8";
export var colorDot = "_ao-0";
export var colorDotLarge = "_ao-2";
export var colorDotSmall = "_ao-1";
export var colorGreen = "_ao-7";
export var colorGrey = "_ao-3";
export var colorOrange = "_ao-5";
export var colorPink = "_ao-a";
export var colorPurple = "_ao-9";
export var colorRed = "_ao-4";
export var colorYellow = "_ao-6";